import React, { useState } from 'react'
import { Link } from 'react-router-dom';

export default function HomeBanner() {
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    { 
      title: "Tropical Luminance", 
      place: "Goa", 
      img: "/image/banner-small-1.webp",
      mobileimg: "/image/banner-mobile-1.webp",
      bg: "/image/banner-big-1.webp",
      link: "/resort-de-coracao-goa", 
    },

    { 
      title: "to the Wilds", 
      place: "Jim Corbett", 
      img: "/image/banner-small-2.webp",
      mobileimg: "/image/banner-mobile-2.webp",
      bg: "/image/banner-big-2.webp",
      link: "/resort-de-coracao-corbett", 
    },

    { 
      title: "Pathways to discovery", 
      place: "Rishikesh", 
      img: "/image/banner-small-3.webp",
      mobileimg: "/image/banner-mobile-3.webp",
      bg: "/image/banner-big-3.webp",
      link: "/resort-de-coracao-rishikesh", 
    },
  ];

  return (
    <>
    <section className="banner-section">
      <div className="container">
        <div className="row justify-content-center">
            <div className="col-lg-10 col-md-11 col-11">
                <div className="banner-card wow animate__animated animate__fadeInLeft" data-wow-duration="1.4s" data-wow-delay="0.1s">
                    {cards.map((card, index) => (
                      <Link key={index} to={card.link} className={`bannercard-item ${activeIndex === index ? "active" : ""}`} onMouseEnter={() => setActiveIndex(index)}>
                        <img src={card.img} className="img-responsive bannercard-desktop" alt="banner" />
                        <img src={card.mobileimg} className="img-responsive bannercard-mobile" alt="banner" />
                        <div>
                          <p>{card.title}</p>
                          {index === 0 && (
                            <h1 className="banheading">{card.place}</h1>
                          )}

                          {index === 1 && (
                            <h2 className="banheading">{card.place}</h2>
                          )}

                          {index === 2 && (
                            <h3 className="banheading">{card.place}</h3>
                          )}
                        </div>
                      </Link>
                    ))}
                </div>

                <p className='sr-only'>Hotel In Jim Corbett & Goa | Resort De Coracao</p>
            </div>
        </div>
      </div>

        <div className="banner-backimage">
          {cards.map((card, index) => (
            <div key={index} className={`banner-bg ${activeIndex === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${card.bg})` }}/>
          ))}
        </div>


        <a href="https://api.whatsapp.com/send?phone=9292928787" target="_blank" aria-label="Message Us on Whatsapp" class="float-whatsapp" rel="noreferrer"><img src="/image/whatsapp.webp" alt="whatsapp" /></a>
    </section> 
    </>
  )
}
